import { Injectable } from '@visiba/instantiation';
import type { SearchLimitationResult } from './generated/clientv2/models';
import { HttpResponse, HttpService } from '@application/http.service';
import { ApiBaseClient } from './_api_base_client';

@Injectable()
export class SearchLimitationApiService extends ApiBaseClient {
	constructor(private readonly httpService: HttpService) {
		super('receptions');
	}

	public getSearchLimitation(receptionId: number, limitationId: string): HttpResponse<SearchLimitationResult> {
		const params = new URLSearchParams();
		params.append('limitationId', limitationId);

		return this.httpService.get(`${this.baseUri}/${receptionId}/SearchLimitation?${params.toString()}`);
	}
}
